var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('base-dialog', {
    model: {
      value: _vm.isVisible,
      callback: function callback($$v) {
        _vm.isVisible = $$v;
      },
      expression: "isVisible"
    }
  }, [_c('dialog-template', {
    staticStyle: {
      "max-width": "720px"
    },
    attrs: {
      "mobile-stretch": ""
    }
  }, [_c('div', {
    class: _vm.$style.header,
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_c('h3', {
    class: _vm.$style.title,
    domProps: {
      "textContent": _vm._s(_vm.$t('report.datepicker.title'))
    }
  }), _c('datepicker-toolbar', {
    on: {
      "change": _vm.handleChangeDatepicker,
      "show-presets": _vm.handleShownPresets
    },
    model: {
      value: _vm.range,
      callback: function callback($$v) {
        _vm.range = $$v;
      },
      expression: "range"
    }
  })], 1), _c('template', {
    slot: "content"
  }, [_c('responsive-controller', {
    scopedSlots: _vm._u([{
      key: "tablet",
      fn: function fn() {
        return [_c('datepicker-scroller', {
          attrs: {
            "show-calendar": false,
            "range": ""
          },
          model: {
            value: _vm.range,
            callback: function callback($$v) {
              _vm.range = $$v;
            },
            expression: "range"
          }
        })];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_c('datepicker-calendar', {
          attrs: {
            "show-calendar": false,
            "range": ""
          },
          model: {
            value: _vm.range,
            callback: function callback($$v) {
              _vm.range = $$v;
            },
            expression: "range"
          }
        })];
      },
      proxy: true
    }])
  })], 1), _c('div', {
    class: _vm.$style.footer,
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('simple-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleSelect
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.save')) + " ")]), _c('simple-button', {
    attrs: {
      "variant": "transparent"
    },
    on: {
      "click": function click($event) {
        _vm.isVisible = false;
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.$t('common.cancel')) + " ")])], 1)], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }